export interface FooterNavLinkItem {
  id: string;
  title: string;
  url: string;
  target: string;
}

export interface FooterSocialLinkItem {
  id: string;
  name: string;
  url: string;
  iconUrl: string;
  target: string;
}

export interface FooterSiteInformationClickDetail {
  id: string;
  name: string;
  originalEvent: Event;
  sourceNode: HTMLElement;
}

export const socialMediaData: FooterSocialLinkItem[] = [
  {
    id: 'sap-facebook-media',
    url: 'https://www.facebook.com/SAP',
    name: 'facebook',
    iconUrl: 'https://cdn.udex.services.sap.com/dds/design-tokens/assets/icons/facebook.svg',
    target: '_blank'
  },
  {
    id: 'sap-youtube-media',
    url: 'https://www.youtube.com/@SAP',
    name: 'youtube',
    iconUrl: 'https://cdn.udex.services.sap.com/dds/design-tokens/assets/icons/youtube.svg',
    target: '_blank'
  },
  {
    id: 'sap-linkedin-media',
    url: 'https://www.linkedin.com/company/sap',
    name: 'linkedin',
    iconUrl: 'https://cdn.udex.services.sap.com/dds/design-tokens/assets/icons/linkedin.svg',
    target: '_blank'
  },
  {
    id: 'sap-instagram-media',
    url: 'https://www.instagram.com/sap',
    name: 'instagram',
    iconUrl: 'https://cdn.udex.services.sap.com/dds/design-tokens/assets/icons/instagram.svg',
    target: '_blank'
  },
];

export const quickLinksData: FooterNavLinkItem[] = [
  {
    title: 'SAP Store',
    url: 'https://www.sap.com/store.html',
    id: 'sap-store-link',
    target: '_self'
  },
  {
    title: 'FAQs',
    url: 'https://www.sap.com/store/faq.html',
    id: 'sap-store-faqs',
    target: '_self'
  },
  {
    title: 'Buy more licenses',
    url: 'https://www.sap.com/store/buy-more-licenses.html',
    id: 'buy-more-licenses',
    target: '_self'
  },
  {
    title: 'Become a partner ',
    url: 'https://www.store.sap.com/dcp/en/partner-with-us',
    id: 'become-a-partner',
    target: '_self'
  },
  {
    title: 'SAP Store terms of use',
    url: 'https://www.store.sap.com/dcp/en/terms-of-use',
    target: '_self',
    id: 'sap-store-terms-of-use'
  },
  {
    title: 'Privacy Statement',
    url: 'https://www.store.sap.com/dcp/en/privacy',
    target: '_self',
    id: 'sap-store-privacy-statement'
  }]

export const trendingLinksData: FooterNavLinkItem[] = [
  {
    title: 'SAP Sapphire',
    url: 'https://www.sap.com/events/sapphire.html',
    target: '_self',
    id: 'sap-sapphire'
  },
  {
    title: 'SAP Business Suite',
    url: 'https://www.sap.com/products/business-suite.html',
    target: '_self',
    id: 'sap-business-suite'
  },
  {
    title: 'SAP Business Data Cloud',
    url: 'https://www.sap.com/products/data-cloud.html',
    target: '_self',
    id: 'sap-business-data-cloud'
  },
  {
    title: 'SAP Business AI',
    url: 'https://www.sap.com/products/artificial-intelligence.html',
    target: '_self',
    id: 'sap-business-ai'
  },
  {
    title: 'Sustainability',
    url: 'https://www.sap.com/products/sustainability.html',
    target: '_self',
    id: 'footer-sustainability'
  },
  {
    title: 'Partner ecosystem',
    url: 'https://partneredge.sap.com/en/',
    target: '_self',
    id: 'partner-ecosystem'
  },
]

export const aboutSapLinksData: FooterNavLinkItem[] = [
  {
    title: 'Company information',
    url: 'https://www.sap.com/about/company.html',
    target: '_self',
    id: 'company-information'
  },
  {
    title: 'Worldwide directory',
    url: 'https://www.sap.com/about/company/office-locations.html',
    target: '_self',
    id: 'worldwide-directory'
  },
  {
    title: 'Investor Relations',
    url: 'https://www.sap.com/investors/en.html',
    target: '_self',
    id: 'investor-relations'
  },
  {
    title: 'Careers',
    url: 'https://jobs.sap.com/?utm_source=CareerSite&utm_campaign=CorpSite_FT',
    target: '_self',
    id: 'footer-careers'
  },
  {
    title: 'News and press',
    url: 'https://news.sap.com/',
    target: '_self',
    id: 'news-and-press'
  },
  {
    title: 'Events',
    url: 'https://www.sap.com/events.html',
    target: '_self',
    id: 'footer-events'
  },
  {
    title: 'Customer stories',
    url: 'https://www.sap.com/about/customer-stories.html',
    target: '_self',
    id: 'customer-stories'
  },
  {
    title: 'Newsletter',
    url: 'https://www.sap.com/dashboard/newsletters.html',
    target: '_self',
    id: 'footer-newsletter'
  },
]

export const siteInformationLinksData: FooterNavLinkItem[] = [
  {
    title: 'Privacy',
    url: 'https://www.sap.com/about/legal/privacy.html',
    target: '_self',
    id: 'footer-privacy'
  },
  {
    title: 'Terms of use',
    url: 'https://www.sap.com/about/legal/terms-of-use.html',
    target: '_self',
    id: 'terms-of-use'
  },
  {
    title: 'Legal disclosure',
    url: 'https://www.sap.com/about/legal/impressum.html',
    target: '_self',
    id: 'legal-disclosure'
  },
  {
    title: 'Copyright',
    url: 'https://www.sap.com/about/legal/copyright.html',
    target: '_self',
    id: 'footer-copyright'
  },
  {
    title: 'Trademark',
    url: 'https://www.sap.com/about/legal/trademark.html',
    target: '_self',
    id: 'footer-trademark'
  },
  {
    title: 'Cookie statement',
    url: 'https://www.sap.com/about/legal/privacy/cookies.html',
    target: '_self',
    id: 'cookie-statement'
  },
  {
    title: 'Cookie preferences',
    url: 'javascript:void(0);', //NOSONAR
    target: '_self',
    id: 'cookie-preferences'
  }
]
